function getData(id) {
  const selector = document.querySelector(id);
  if (!selector) {
    return null;
  }
  return JSON.parse(document.querySelector(id).textContent);
}

export default getData;
